export const CREATING_TEAM = 'Creating Team';
export const RETRIEVING_TEAM = 'Retrieving Team';
export const UPDATING_TEAM = 'Updating Team';
export const DELETING_TEAM = 'Deleting Team';
